"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const GoogleMap_1 = require("ts/classes/GoogleMap");
const axios_1 = __importDefault(require("axios"));
let StoreLocator = class StoreLocator extends vue_1.default {
    constructor() {
        super(...arguments);
        this.googleMap = GoogleMap_1.GoogleMap;
        this.address = '';
        this.show = false;
        this.results = true;
        this.searching = false;
        this.list = false;
        this.showToggles = false;
        this.apiUrl = '/rest/api/v1/storelocator/';
    }
    async mounted() {
        if (window.innerWidth < 992) {
            this.showToggles = true;
        }
        this.mapMeta = this.getBaseMapMeta();
        this.map = new GoogleMap_1.GoogleMap(this.$refs.map, this.mapMeta.lat, this.mapMeta.lng, this.mapMeta.zoom);
        this.locations = [];
        await this.getLocations();
        this.setMapMeta();
    }
    getBaseMapMeta() {
        return {
            lat: 52.0352079,
            lng: 4.9373648,
            zoom: 8
        };
    }
    setMapMeta() {
        if (isNaN(this.mapMeta.lat) || isNaN(this.mapMeta.lng)) {
            this.mapMeta = this.getBaseMapMeta();
        }
        this.map.center(this.mapMeta.lat, this.mapMeta.lng);
    }
    async getLocations() {
        this.hideLocations();
        this.startSearch();
        this.hasResults();
        const address = this.address;
        const response = await new Promise(async (resolve) => {
            await axios_1.default
                .get(this.apiUrl + 'getLocations', {
                params: {
                    address,
                }
            })
                .then(function (response) {
                return resolve(response);
            })
                .catch(function (error) {
                return resolve(error.response.data);
            });
        });
        if ((response === null || response === void 0 ? void 0 : response.data.locations) != undefined && (response === null || response === void 0 ? void 0 : response.data.locations.length) >= 1) {
            this.locations = response === null || response === void 0 ? void 0 : response.data.locations;
            await this.setLocations();
            if (response.data.address != null) {
                this.mapMeta.lat = response.data.address.lat;
                this.mapMeta.lng = response.data.address.long;
                this.mapMeta.zoom = 5;
            }
            else {
                this.mapMeta = this.getBaseMapMeta();
            }
            this.setMapMeta();
            this.showLocations();
        }
        else {
            this.hideLocations();
            this.noResults();
        }
    }
    async setLocations() {
        this.map.clearLocations();
        if (this.locations.length) {
            this.map.addLocations(this.locations.map((l) => ({
                ...l.location,
                title: l.post_title,
                dealer_type: l.fields.dealer_type,
            })));
        }
    }
    hideLocations() {
        this.show = false;
    }
    showLocations() {
        this.stopSearch();
        this.show = true;
    }
    noResults() {
        this.stopSearch();
        this.results = false;
    }
    hasResults() {
        this.results = true;
    }
    startSearch() {
        this.searching = true;
    }
    stopSearch() {
        this.searching = false;
    }
    toggleList() {
        this.list = !this.list;
    }
    getRouteUrl(location) {
        return GoogleMap_1.GoogleMap.getNavigateToUrl(location);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], StoreLocator.prototype, "button", void 0);
StoreLocator = __decorate([
    vue_property_decorator_1.Component
], StoreLocator);
exports.default = StoreLocator;
